import { FacilitiesRequests } from '@/services/facilities.requests'
const facilitiesService = new FacilitiesRequests()

const state = {
  list: []
}

const getters = {
  checkFacilityId: (state) => (id) => {
    return state.list.some(facility => facility.id == id)
  },
  getBaseCurrencyId: (state) => (id) => {
    var facility = state.list.find(facility => facility.id == id)
    return facility ? facility['baseCurrencyId'] : null
  },
  getFirstFacilityId: (state) => () => {
    var facility = state.list.find(facility => facility.id)
    return facility ? facility.id : null
  }
}

const actions = {
  get ({}, { id }) {
    return new Promise((resolve, reject) => {
      facilitiesService.get(id).then((facility) => {
        resolve(facility)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  list ({ state }) {
    return new Promise((resolve, reject) => {
      facilitiesService.list().then(async (facilities) => {
        state.list = facilities
        resolve(facilities)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
